<template>
	<div class="timBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="timBtns">
			<div class="timBtn supHove3 clred" v-if="type == 1" @click="xzFn">
				<img src="@/assets/img/编组 (4).png" alt="" />
				<span>确认模板</span>
			</div>
			<div class="timBtn timBtn1 supHove3" v-if="type == 2" @click="qxFn">
				<img src="@/assets/img/编组 (5).png" alt="" />
				<span>取消组卷</span>
			</div>
			<div class="timBtn timBtn2 supHove3" v-if="type == 2" @click="qrFn">
				<img src="@/assets/img/编组 (4).png" alt="" />
				<span>确认组卷</span>
			</div>
		</div>
		<dialogBox :dialogFlag="subFlag" @callFn="subFlag = false" title="">
			<div class="tcsBox">
				<img src="@/assets/img/编组 5.png" alt="" />
				<h2>组卷完成后您将无法修改试卷题目</h2>
				<p>请仔细检查确定无误后提交试卷</p>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn" @click="subFlag = false">继续组卷</div>
						<div class="loadBtn loadBtnQr" @click="subFn">确认完成</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<h1>
			<span v-if="!titFlag">{{ titVal }}</span>
			<el-input class="myInput" @blur="setnFn" @change="setnFn" v-if="titFlag" v-model="titVal"></el-input>
			<i @click="bxFn" v-if="type == 2" class="el-icon-edit"></i>
		</h1>
		<h2>（选择题{{ tmNum }}小题，每题{{ configData.configValue || '' }}分，共{{ tmNum * configData.configValue || '' }}分）</h2>
		<div class="timuCont">
			<div class="timuZj">
				<div class="timuTm">第一节</div>
				<div class="timuTit">
					听下面
					<span>5</span>
					段录音。每段录音后有一个小题，从题中所给的
					<span>A、B、C</span>
					三个选项中选出最佳选项。听完每段录音后，你都有
					<span>10</span>
					秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。
				</div>
				<div class="timuXcont">
					<div class="timuXitems" v-for="(item, index) in stArr" :key="index">
						<div class="timuXitem" :data-slot-uuid="item.uuid" @click="stBtn(item)" v-if="!item.stdec.examinationQuestionId">
							{{ item.num }}{{ item.type }}
							<p v-if="type == 2">
								<i class="el-icon-plus"></i>
								添加试题
							</p>
						</div>
						<div class="timuTcont" v-if="type == 2 && item.stdec.examinationQuestionId">
							<div v-for="(items, indexs) in item.stdec.yydSmallQuestionList" :key="indexs">
								<h2>
									<div class="khao">()</div>
									{{ item?.listTh[indexs] }}、{{ items.title }}
								</h2>
								<p v-for="(a, b) in items.yydSmallQuestionOptionList" :key="b">{{ a.number }} 、{{ a.content }}</p>
								<div class="timuTcontBtn supHove3" @click="stBtn(item)">
									<img src="@/assets/img/编组 (7).png" alt="" />
									<span>替换试题</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="timuZj">
				<div class="timuTm">第二节</div>
				<div class="timuTit">
					听下面
					<span>5</span>
					段录音。每段录音后有几个小题，从题中所给的
					<span>A、B、C</span>
					三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题
					<span>5</span>
					秒钟；听完后，每小题都有
					<span>5</span>
					秒钟的作答时间。每段录音播放两遍。
				</div>
				<div v-for="(item, index) in this.mxItem.templateDetail" :key="index">
					<div class="timuP">
						听第{{ 6 + index }}段录音，回答第{{ item.listTh.length > 2 ? item.listTh[0] + '至' + item.listTh[item.listTh.length - 1] : item.listTh.join('、') }}题。
					</div>
					<div class="timuXcont">
						<div class="timuXitem" :data-slot-uuid="item.uuid" @click="stBtn(item)" v-if="!item.stdec.examinationQuestionId">
							{{ item.num }}{{ item.type }}
							<p v-if="type == 2">
								<i class="el-icon-plus"></i>
								添加试题
							</p>
						</div>
						<div class="timuTcont" v-if="type == 2 && item.stdec.examinationQuestionId">
							<div v-for="(items, indexs) in item.stdec.yydSmallQuestionList" :key="indexs">
								<h2>
									<div class="khao">()</div>
									{{ item?.listTh[indexs] }}、{{ items.title }}
								</h2>
								<p v-for="(a, b) in items.yydSmallQuestionOptionList" :key="b">{{ a.number }} 、{{ a.content }}</p>
								<div class="timuTcontBtn supHove3" @click="stBtn(item)">
									<img src="@/assets/img/编组 (7).png" alt="" />
									<span>替换试题</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'timuXz',
	data() {
		return {
			strName: '',
			type: this.$route.query.tjStatus ? 2 : 1,
			configData: {},
			fullscreenLoading: false,
			titVal: moment(new Date()).format('YYYY年MM月DD日') + '听力试卷',
			titFlag: false,
			subFlag: false,
			stArr: [
				{
					listTh: [1],
					num: 1,
					uuid: 0,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [2],
					num: 1,
					uuid: 1,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [3],
					num: 1,
					uuid: 2,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [4],
					num: 1,
					uuid: 3,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [5],
					num: 1,
					uuid: 4,
					stdec: {},
					type: 'Q'
				}
			]
		};
	},
	props: {
		mxItem: {
			type: Object,
			default: {}
		}
	},
	components: {
		dialogBox
	},
	computed: {
		...mapState(['temTestquest']),
		tmNum() {
			return this.mxItem.templateDetail[this.mxItem.templateDetail.length - 1]?.listTh[this.mxItem.templateDetail[this.mxItem.templateDetail.length - 1]?.listTh.length - 1];
		}
	},
	watch: {
		mxItem() {
			if (this.mxItem.templateDetail) {
				let str = '';
				str = this.mxItem.templateDetail
					.map((item) => {
						return item.type;
					})
					.join(',');
				if (str.includes('D') && str.includes('Q')) {
					this.strName = '对话或独白';
				}
				if (str.includes('Q') && !str.includes('D')) {
					this.strName = '对话';
				}
				if (str.includes('D') && !str.includes('Q')) {
					this.strName = '独白';
				}
			}
		},
		type(val) {
			if (val == 1) {
				this.$emit('disFn', false);
			} else {
				this.$emit('disFn', true);
			}
		}
	},
	methods: {
		setnFn() {
			this.titFlag = false;
		},
		qrFn() {
			let flag = false;
			let str = '';
			this.temTestquest.examinationQuestionIdList.forEach((item, index) => {
				if (!item.stdec.examinationQuestionId) {
					flag = true;
					str += index + 1 + ',';
				}
			});
			if (flag) {
				this.$message({
					type: 'warning',
					message: `请填写完第${str.substring(0, str.length - 1)}题后，再提交哦`
				});
				return;
			}
			console.log(this.temTestquest, 55999999);
			this.subFlag = true;
			// this.$router.push({
			//     path:'tihuanKt',
			//     query: {
			//         tjStatus: 1,
			//         txt:'试题确认',
			//     }
			// })
		},
		subFn() {
			console.log(this.temTestquest, 7778);
			let flag = false;
			let examinationQuestionIdList = this.temTestquest.examinationQuestionIdList.map((item) => {
				if (item.stdec.examinationQuestionId) {
					return item.stdec.examinationQuestionId;
				} else {
					flag = true;
					return '';
				}
			});
			if (flag) {
				this.$message({
					type: 'warning',
					message: '请填写完成题目后，在提交'
				});
				return;
			}
			let set = this.$loading(this.$pre);
			console.log(examinationQuestionIdList, 8887777);
			this.$http
				.post('api/app/yydGroupQuestionExam', {
					examinationQuestionIdList,
					templateId: this.temTestquest.templateId,
					title: this.titVal
				})
				.then((res) => {
					set.close();
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: '创建成功'
						});
						this.subFlag = false;
						this.$store.commit('setTemTest', {});
						this.$router.push({
							path: 'mySj'
						});
					}
				});
		},
		// qrFn() {
		//     let flag = false
		//     let str = ''
		//     this.temTestquest.examinationQuestionIdList.forEach((item,index) => {
		//         if(!item.stdec.examinationQuestionId){
		//             flag= true
		//             str += (index+1) + ','
		//         }
		//     })
		//     if(flag){
		//         this.$message({
		//             type: 'warning',
		//             message: `请填写完第${str.substring(0,str.length-1)}题后，再提交哦`
		//         });
		//         return
		//     }
		//     console.log(this.temTestquest,55999999)
		//     this.$router.push({
		//         path:'tihuanKt',
		//         query: {
		//             tjStatus: 1,
		//             txt:'试题确认',
		//         }
		//     })
		// },
		qxFn() {
			this.$emit('isZjFn', false);
			this.type = 1;
			this.titVal = moment(new Date()).format('YYYY年MM月DD日') + '听力试卷';
			this.$store.commit('setTemTest', {});
			this.stArr = [
				{
					listTh: [1],
					num: 1,
					uuid: 0,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [2],
					num: 1,
					uuid: 1,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [3],
					num: 1,
					uuid: 2,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [4],
					num: 1,
					uuid: 3,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [5],
					num: 1,
					uuid: 4,
					stdec: {},
					type: 'Q'
				}
			];
			if (this.mxItem?.templateDetail?.length) {
				this.mxItem.templateDetail.forEach((item) => {
					this.$set(item, 'stdec', {});
				});
			}
		},
		bxFn() {
			this.titFlag = !this.titFlag;
		},
		xzFn() {
			this.$emit('isZjFn', true);
			this.type = 2;
			this.$store.commit('setTemTest', {
				title: '',
				templateId: this.mxItem.templateId,
				examinationQuestionIdList: [...this.stArr, ...this.mxItem.templateDetail]
			});
		},
		stBtn(item) {
			if (this.type == 1) {
				return;
			}
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			sessionStorage.setItem('xuanzMb_scrollTop', scrollTop);
			this.$router.push({
				path: 'zujuan',
				query: {
					type: 2,
					stStand: JSON.stringify(item)
				}
			});
		},
		inInfo() {
			console.log(this.temTestquest.examinationQuestionIdList, this.stArr, this.mxItem, 2222);
			this.temTestquest.examinationQuestionIdList.forEach((item, index) => {
				if (index < 5) {
					this.stArr.map((i, s) => {
						if (item.uuid == i.uuid) {
							this.$set(i, 'stdec', item.stdec);
						}
					});
				} else {
					this.mxItem.templateDetail.map((i, s) => {
						if (item.uuid == i.uuid) {
							i.stdec = item.stdec;
						}
					});
				}
			});
			console.log(this.stArr, this.mxItem, 44444);
		},
		scrollToFirstEmpty() {
			const list = this.temTestquest.examinationQuestionIdList;
			if (!list?.length) return;
			const firstEmpty = list.find((item) => !item.stdec?.examinationQuestionId);
			if (!firstEmpty) {
				this.restoreScroll();
				return;
			}
			sessionStorage.removeItem('xuanzMb_scrollTop');
			this.$nextTick(() => {
				const slotEl = this.$el.querySelector(`[data-slot-uuid="${firstEmpty.uuid}"]`);
				if (!slotEl) return;
				let targetEl = slotEl;
				const titleEl = slotEl.closest('.timuXcont')?.previousElementSibling;
				if (titleEl?.classList?.contains('timuP')) {
					targetEl = titleEl;
				}
				const headerOffset = 20;
				const top = targetEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;
				window.scrollTo(0, Math.max(0, top));
			});
		},
		restoreScroll() {
			this.$nextTick(() => {
				const saved = sessionStorage.getItem('xuanzMb_scrollTop');
				if (saved !== null) {
					window.scrollTo(0, Number(saved));
					sessionStorage.removeItem('xuanzMb_scrollTop');
				}
			});
		}
	},
	activated() {
		const { tjStatus } = this.$route.query;
		console.log(this.temTestquest, '查询');
		if (!this.temTestquest.examinationQuestionIdList) {
			this.type = 1;
			this.stArr = [
				{
					listTh: [1],
					num: 1,
					uuid: 0,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [2],
					num: 1,
					uuid: 1,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [3],
					num: 1,
					uuid: 2,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [4],
					num: 1,
					uuid: 3,
					stdec: {},
					type: 'Q'
				},
				{
					listTh: [5],
					num: 1,
					uuid: 4,
					stdec: {},
					type: 'Q'
				}
			];
		}
		if (tjStatus && this.temTestquest.examinationQuestionIdList) {
			this.$nextTick(() => {
				this.inInfo();
				this.$nextTick(() => {
					this.scrollToFirstEmpty();
				});
			});
		}
	},
	mounted() {
		// 得分
		this.fullscreenLoading = true;
		this.$http.get(`api/system/dict/data/config/sys.question.score`).then((res) => {
			this.fullscreenLoading = false;
			if (res.code == 200) {
				this.configData = res.data;
			}
		});
	}
};
</script>
<style lang="scss" scoped>
.timBox {
	margin-top: 10px;
	background: #ffffff;
	border-radius: 4px;
	padding: 38px 65px 100px;
	position: relative;
	h1 {
		font-size: 28px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 25px;
		text-align: center;
		height: 40px;
		i {
			color: #1d7b3a;
			cursor: pointer;
			margin-left: 8px;
		}
		.myInput {
			width: 380px;
			text-align: center;
			font-size: 28px;
			color: #000000;
			font-weight: bold;
		}
	}
	h2 {
		font-size: 18px;
		text-align: center;
		color: #000000;
		margin-bottom: 62px;
	}
	.timuCont {
		.timuZj {
			margin-bottom: 40px;
			.timuTm {
				margin-bottom: 13px;
				color: #000000;
				font-size: 18px;
				font-weight: bold;
				text-indent: 2em;
			}
			.timuTit {
				color: #3d3d3d;
				text-indent: 2em;
				line-height: 1.7;
				margin-bottom: 36px;
				span {
					font-weight: bold;
				}
			}
			.timuP {
				font-weight: bold;
				margin-bottom: 13px;
				color: #000000;
				font-size: 16px;
				text-indent: 2em;
			}
			.timuXcont {
				.timuXitem {
					height: 60px;
					background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
					border-radius: 6px;
					border: 1px solid #e0e0e0;
					display: flex;
					align-items: center;
					cursor: pointer;
					padding-left: 14px;
					font-size: 14px;
					color: #000000;
					margin-bottom: 10px;
					position: relative;
					p {
						position: absolute;
						color: #8b8b8b;
						font-size: 12px;
						left: 50%;
						transform: translateX(-50%);
						i {
							font-weight: bold;
							margin-right: 2px;
						}
					}
				}
				.timuXactive {
					p {
						color: #1d7b3a !important;
					}
				}
				.timuTcont {
					padding: 15px 34px 9px;
					margin: 15px 0 9px;
					text-align: left;
					border-radius: 15px;
					position: relative;
					&:hover {
						background: #e8f1eb;
					}
					> div {
						margin-bottom: 20px;
					}
					.timuTcontBtn {
						position: absolute;
						cursor: pointer;
						right: 16px;
						bottom: 17px;
						width: 105px;
						height: 36px;
						background: #1d7b3a;
						border-radius: 7px;
						border: 1px solid #14652d;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 14px;
						color: #ffffff;
						z-index: 1111;
						img {
							width: 15px;
							height: 12px;
							margin-right: 6px;
						}
					}
					h2 {
						display: flex;
						margin-bottom: 12px;
						font-weight: bold;
						.khao {
							width: 102px;
							letter-spacing: 60px;
						}
					}
					p {
						padding-left: 102px;
						line-height: 2;
					}
				}
			}
		}
	}
	.timBtns {
		position: -webkit-sticky; /* Safari */
		position: sticky;
		top: 30px;
		z-index: 999;
		width: 65px;
		margin-left: -140px;
		float: left;
		.timBtn {
			width: 65px;
			height: 65px;
			background: #1d7b3a;
			border-radius: 6px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			color: #fff;
			font-size: 14px;
			cursor: pointer;
			margin-bottom: 15px;
			img {
				width: 18px;
				height: 21px;
				margin-bottom: 5px;
			}
		}
		.clred {
			background: #d33931;
		}
		.timBtn1 {
			background: #ffffff;
			color: #82807c;
			img {
				width: 21px;
				height: 21px;
				margin-bottom: 5px;
			}
		}
		.timBtn2 {
			background: #d33931;
			color: #fff;
		}
	}
}
.tcsBox {
	margin: 0 0 40px;
	text-align: center;
	img {
		width: 86px;
		margin-bottom: 34px;
	}
	h2 {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 11px;
	}
	p {
		color: #9c9c9c;
	}
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}
</style>
